// `folder: null` asks for files in no folder, so it has to survive serialisation.
const NO_FOLDER_VALUE = "null";
export default function buildGetMediaFilesUrl({ baseUrl, ...request }) {
    const queryParams = new URLSearchParams();
    Object.entries(request).forEach(([key, value]) => {
        if (value === undefined || value === "") {
            return;
        }
        if (Array.isArray(value)) {
            value.forEach((entry) => queryParams.append(key, String(entry)));
            return;
        }
        queryParams.set(key, value === null ? NO_FOLDER_VALUE : String(value));
    });
    const query = queryParams.toString();
    return query ? `${baseUrl}?${query}` : baseUrl;
}
